require.register("modules/m04/m04-activity/page-12a-co/page-12a-co", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page12aco = _.defaults({
  initialized: function (view) {

  },
  loaded: function (view) {

  },
  playing: function (view) {

  },
  paused: function (view) {

  },
  stopped: function (view) {

  },
  completed: function (view) {
  },
  unloading: function (view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page12aco;

  
});

